import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const Inspection = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionHistoryDetail/InsectionHistoryDetail"
    )
);

export const InspectionDetails = () => {
  return (
    <Layout>
      <Inspection />
    </Layout>
  );
};
